import { state } from '@/store';

export function isPromoStatusPending() {
  return !state.promoStatusLoaded;
}

export function markPromoStatusLoaded() {
  state.promoStatusLoaded = true;
}

/** Блокирует promo-действие, пока не получен ответ /api/main/settings. */
export function blockIfPromoStatusPending() {
  return isPromoStatusPending();
}
